import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { selectReturnDetails } from 'shared/store/product/selector';
import { State } from 'shared/store/types';
import GenuineProduct from './GenuineProduct';
import Return from './Return';


const Wrapper = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  background-color: ${({ theme }) => hexToRgb(theme.colors.state, 0.08)};
  border-top: 1px solid ${({ theme }) => hexToRgb(theme.colors.state, 0.16)};
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.72)};
  bottom: 0;
  left: 0;
  padding: ${({ theme }) => theme.spacing.spacing60} ${({ theme }) => theme.spacing.spacing120};
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  @media (min-width: 768px) and (max-width: 1024px){
    padding-left: ${({ theme }) => theme.spacing.spacing120};
  }
`;

const SoldBy = styled.div`
  display: flex;
  float: left;
  margin-right: 0;
`;
const SoldByContainer = styled.div`
  max-width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ theme }) => theme.typography.subTitleMedium};
`;
const SoldByName = styled.span`
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.92)};
  padding-right: 0;
  text-transform: uppercase;
  width: 122px;
  ${({ theme }) => theme.typography.bodyMedium};
`;
const ReturnDetails = () => {
  const returnDetails = useSelector((state: State) => selectReturnDetails(state));
  const {
    genuineProductText = '',
    messageOnReturn = '',
    returnAvailable = false,
    sellerName = '',
    primaryCategories,
  } = returnDetails || {};
  return (
    <Wrapper>
      <GenuineProduct genuineProductText={genuineProductText}/>
      <Return
        primaryCategories={primaryCategories}
        returnAvailable={returnAvailable}
        messageOnReturn={messageOnReturn}
      />
      <SoldBy>
        <SoldByContainer>
          <span>
            Sold by :
          </span>
          <SoldByName title={sellerName}>
            {sellerName}
          </SoldByName>
        </SoldByContainer>
      </SoldBy>
    </Wrapper>
  );
};

export default ReturnDetails;
